/**
 * Strict calendar YYYY-MM-DD validation and normalization (UTC calendar day from stored dates).
 * Used by financial list/report filters to avoid implicit local-time rollover issues.
 */

function isLeapYear(year) {
  if (year % 400 === 0) return true;
  if (year % 100 === 0) return false;
  return year % 4 === 0;
}

export function isValidYyyyMmDd(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return false;
  const [yearStr, monthStr, dayStr] = value.split("-");
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);
  if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) return false;
  if (month < 1 || month > 12) return false;
  const maxByMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const maxDay = maxByMonth[month - 1];
  if (day < 1 || day > maxDay) return false;
  return true;
}

export function toYmdFromDateLike(dateLike) {
  if (!dateLike) return "";
  if (typeof dateLike === "string") {
    const candidate = dateLike.includes("T") ? dateLike.slice(0, 10) : dateLike.trim();
    return isValidYyyyMmDd(candidate) ? candidate : "";
  }
  if (dateLike instanceof Date && !Number.isNaN(dateLike.getTime())) {
    const y = String(dateLike.getUTCFullYear());
    const m = String(dateLike.getUTCMonth() + 1).padStart(2, "0");
    const d = String(dateLike.getUTCDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  return "";
}
